import React from "react";
import styled from "styled-components";
import { PrimaryButton } from "./Button";

import LoadingIndicator from "../assets/icons/LoadingRings.svg";

const ButtonWrapper = styled(PrimaryButton)`
  img {
    position: relative;

    bottom: 10px;
  }
`;

export default function LoadingButton({ loading, children, ...props }) {
  return (
    <ButtonWrapper {...props}>
      {loading ? <img src={LoadingIndicator} alt="Loading" /> : children}
    </ButtonWrapper>
  );
}
